import { render, staticRenderFns } from "./SizeController.vue?vue&type=template&id=67b3b0d6&"
import script from "./SizeController.vue?vue&type=script&lang=ts&"
export * from "./SizeController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports